export default __webpack_public_path__ + "static/media/39_mobile.f2b132c0.jpeg";